function FullScreenGallery() {
	this.galleryButton = document.getElementById('openGallery');
	this.build();
}

FullScreenGallery.prototype.build = function () {
	const that = this;
	if(!mobileCheck.isMobile && this.galleryButton){
		this.galleryButton.style.opacity = 0;
		this.galleryButton.style.transform = 'translate(-50%, -50%)';
		$('.section-gallery').on('mouseenter', function (e) {
			var offset = $(this).offset();
			gsap.to(that.galleryButton, {
				left: e.pageX - offset.left,
				top: e.pageY - offset.top,
				duration: 0
			});
			that.galleryButton.style.opacity = 1;
		}).on('mouseleave', function (e) {
			that.galleryButton.style.opacity = 0;
		}).on('mousemove', function (e) {
			var offset = $(this).offset();
			gsap.to(that.galleryButton, {
				left: e.pageX - offset.left,
				top: e.pageY - offset.top,
			});
		});
	}

	document.querySelectorAll('.gallery-item').forEach(function (elem){
		elem.addEventListener('click', function (){
			openGallery(elem);
		});
	});
};
